export const products = {
  "HT475": {
    id: "HT475",
    name: "HT475",
    subtitle_tr: "Dört Sıralı Preparatör",
    subtitle_en: "Four Rows Preparator",
    description_tr: "HT475, ekim öncesi toprağı hazırlamak için tasarlanmış güçlü bir preparatördür. HARDOX kalitesinde bıçakları ile sertleşmiş toprak ve topakları kolayca parçalar, toprak havalandırmasını artırarak bitkilerin su ve mineral alımını iyileştirir.",
    description_en: "The HT475 is a powerful preparator designed for pre-planting soil preparation. With HARDOX quality blades, it easily breaks down hardened soil and clods, enhancing soil aeration to improve water and mineral uptake for plants.",
    category: "soil-preparation",
    image: "/images/ht475-1.jpg",
    specs: {
      workingWidth: "3490mm",
      rows: "4",
      rowSpacing: "75cm",
      tractorPower: "Min. 130 hp",
      workingCapacity: "6-8 da/saat",
      bladeCount: "96",
    },
    features_tr: [
      "Ekim öncesi toprağı hazırlar",
      "Sertleşmiş toprak ve topakları parçalar",
      "Toprak havalandırmasını artırır",
      "Dayanıklı HARDOX kalitesinde bıçaklar",
      "PTO tahrikli, 1000 rpm dişli kutusu",
    ],
    features_en: [
      "Prepares land for planting",
      "Breaks down hardened soil and clods",
      "Enhances soil aeration for better water/mineral uptake",
      "Durable HARDOX quality blades",
      "PTO driven, 1000 rpm gearbox",
    ],
  },
  "SPIDER275": {
    id: "SPIDER275",
    name: "SPIDER 275",
    subtitle_tr: "İki Sıralı Mekanik Çapa Makinesi",
    subtitle_en: "Double Rows Mechanical Hoeing Machine",
    description_tr: "SPIDER 275, patates bitkilerinin dibini işleyerek minerallerin dağıtımını sağlayan kompakt ve dayanıklı bir mekanik çapa makinesidir. Ekim öncesi karık oluşturmada da kullanılabilir.",
    description_en: "The SPIDER 275 is a compact and durable mechanical hoeing machine that cultivates the base of potato plants to ensure mineral distribution. It can also be used for creating furrows before planting.",
    category: "soil-preparation",
    image: "/images/toprakhazirlama.jpg",
    specs: {
      workingWidth: "3500mm",
      rows: "2",
      rowSpacing: "75cm",
      tractorPower: "Min. 80 hp",
      workingCapacity: "6-8 da/saat",
    },
    features_tr: [
      "Patates bitkilerinin dibini işler",
      "Mineralleri dağıtır",
      "Ekim öncesi karık oluşturmada kullanılır",
      "Kompakt ve dayanıklı yapı",
    ],
    features_en: [
      "Cultivates the base of potato plants",
      "Distributes minerals evenly",
      "Used for creating furrows before planting",
      "Compact and durable construction",
    ],
  },
  "SPIDER475": {
    id: "SPIDER475",
    name: "SPIDER 475",
    subtitle_tr: "Dört Sıralı Mekanik Çapa Makinesi",
    subtitle_en: "Four Rows Mechanical Hoeing Machine",
    description_tr: "SPIDER 475, 4 sıralı yüksek kapasiteli çalışma imkanı sunan güçlü bir mekanik çapa makinesidir. Geniş alan çalışmaları için ideal olup, verimli mineral dağıtımı sağlar.",
    description_en: "The SPIDER 475 is a powerful mechanical hoeing machine offering 4-row high capacity operation. Ideal for large field operations, it ensures efficient mineral distribution.",
    category: "soil-preparation",
    image: "/images/spider475-1.jpg",
    specs: {
      workingWidth: "3500mm",
      rows: "4",
      rowSpacing: "75cm",
      tractorPower: "Min. 100 hp",
      workingCapacity: "8-12 da/saat",
    },
    features_tr: [
      "4 sıralı yüksek kapasiteli çalışma",
      "Patates bitkilerinin dibini işler",
      "Mineral dağıtımı sağlar",
      "Geniş alan çalışmaları için ideal",
    ],
    features_en: [
      "4-row high capacity operation",
      "Cultivates the base of potato plants",
      "Ensures mineral distribution",
      "Ideal for large field operations",
    ],
  },
  "ALPHA275": {
    id: "ALPHA275",
    name: "ALPHA 275",
    subtitle_tr: "İki Sıralı Tam Otomatik Patates Dikim Makinesi",
    subtitle_en: "Double Rows Full Automatic Potato Planter",
    description_tr: "ALPHA 275, insan gücü olmadan dikim yapabilen tam otomatik bir patates dikim makinesidir. Isıl işlem görmüş bıçaklar ve 1000 kg kapasiteli hidrolik hazne ile yüksek verimlilik sunar.",
    description_en: "The ALPHA 275 is a full automatic potato planter that plants without human power. With heat-treated blades and a 1000 kg capacity hydraulic hopper, it delivers high efficiency.",
    category: "potato-planters",
    image: "/images/alpha275-1.jpg",
    specs: {
      workingWidth: "2000mm",
      rows: "2",
      rowSpacing: "70-75 cm",
      spacingAboveRows: "18-41 cm",
      hopperCapacity: "1000 kg",
      tractorPower: "Min. 80 hp",
      workingCapacity: "6-8 da/saat",
    },
    features_tr: [
      "İnsan gücü olmadan dikim yapar",
      "Isıl işlem görmüş ön kazıcı bıçaklar",
      "Yaylı arka kapama ayakları",
      "Farklı tohum boyutlarına uyumlu tohum kapları",
      "Hidrolik hareketli tohum haznesi",
    ],
    features_en: [
      "Plants without human power",
      "Heat-treated front digger blades",
      "Spring-loaded rear closing legs",
      "Adaptable seed cups for different seed sizes",
      "Hydraulic moving seed hopper",
    ],
  },
  "ALPHA475": {
    id: "ALPHA475",
    name: "ALPHA 475",
    subtitle_tr: "Dört Sıralı Tam Otomatik Patates Dikim Makinesi",
    subtitle_en: "Four Rows Full Automatic Potato Planter",
    description_tr: "ALPHA 475, geniş alanlar için tasarlanmış 4 sıralı tam otomatik patates dikim makinesidir. 1800 kg kapasiteli hidrolik hazne ve yüksek verimlilik ile düşük iş gücü maliyeti sağlar.",
    description_en: "The ALPHA 475 is a 4-row full automatic potato planter designed for large areas. With an 1800 kg capacity hydraulic hopper, it provides high efficiency and low labor cost.",
    category: "potato-planters",
    image: "/images/alpha475-1.jpg",
    specs: {
      workingWidth: "3500mm",
      rows: "4",
      rowSpacing: "70-75 cm",
      spacingAboveRows: "18-41 cm",
      hopperCapacity: "1800 kg",
      tractorPower: "Min. 120 hp",
      workingCapacity: "12-16 da/saat",
    },
    features_tr: [
      "4 sıralı tam otomatik dikim",
      "Yüksek kapasiteli hidrolik hazne",
      "Isıl işlem görmüş bıçaklar",
      "Geniş alanlar için ideal",
      "Yüksek verimlilik ve düşük iş gücü maliyeti",
    ],
    features_en: [
      "4-row full automatic planting",
      "High capacity hydraulic hopper",
      "Heat-treated blades",
      "Ideal for large areas",
      "High efficiency and low labor cost",
    ],
  },
  "PDO-2N": {
    id: "PDO-2N",
    name: "PDO-2N",
    subtitle_tr: "İki Sıralı Yarı Otomatik Patates Dikim Makinesi",
    subtitle_en: "Double Rows Semi-Automatic Potato Planter",
    description_tr: "PDO-2N, küçük çiftçiler ve engebeli araziler için uygun, ekonomik bir yarı otomatik patates dikim makinesidir. Isıl işlem görmüş bıçakları ile dayanıklı ve güvenilir performans sunar.",
    description_en: "The PDO-2N is an economical semi-automatic potato planter suitable for small farmers and hilly fields. With heat-treated blades, it offers durable and reliable performance.",
    category: "potato-planters",
    image: "/images/pdo2n-1.jpg",
    specs: {
      workingWidth: "1750mm",
      rows: "2",
      rowSpacing: "70-75 cm",
      spacingAboveRows: "18-41 cm",
      hopperCapacity: "450 kg",
      tractorPower: "Min. 55 hp",
      workingCapacity: "3.5-5 da/saat",
    },
    features_tr: [
      "Küçük çiftçiler ve engebeli araziler için uygun",
      "Standart boyutlu tek tohum kapları",
      "Isıl işlem görmüş ön ve arka bıçaklar",
      "Ekonomik çözüm",
    ],
    features_en: [
      "Suitable for small farmers and hilly fields",
      "Single seed cups with standard dimensions",
      "Heat-treated front and rear blades",
      "Economical solution",
    ],
  },
  "PDO-2F": {
    id: "PDO-2F",
    name: "PDO-2F",
    subtitle_tr: "İki Sıralı Gübreli Yarı Otomatik Patates Dikim Makinesi",
    subtitle_en: "Double Rows Semi-Automatic Potato Planter with Fertilizer",
    description_tr: "PDO-2F, entegre gübre seçeneği sunan yarı otomatik bir patates dikim makinesidir. Dekar başına 50 kg'a kadar gübre ayarı yapılabilir. Küçük çiftçiler için idealdir.",
    description_en: "The PDO-2F is a semi-automatic potato planter with an integrated fertilizer option. Fertilizer can be set up to 50 kg per decare. Ideal for small farmers.",
    category: "potato-planters",
    image: "/images/pdo2n-1.jpg",
    specs: {
      workingWidth: "1750mm",
      rows: "2",
      rowSpacing: "70-75 cm",
      spacingAboveRows: "18-41 cm",
      hopperCapacity: "450 kg",
      fertilizerCapacity: "100 kg",
      tractorPower: "Min. 55 hp",
      workingCapacity: "3.5-5 da/saat",
    },
    features_tr: [
      "Entegre gübre seçeneği",
      "Dekar başına 50 kg'a kadar gübre ayarı",
      "Küçük çiftçiler için ideal",
      "Isıl işlem görmüş bıçaklar",
    ],
    features_en: [
      "Integrated fertilizer option",
      "Fertilizer setting up to 50 kg per decare",
      "Ideal for small farmers",
      "Heat-treated blades",
    ],
  },
  "PDO-4N": {
    id: "PDO-4N",
    name: "PDO-4N",
    subtitle_tr: "Dört Sıralı Yarı Otomatik Patates Dikim Makinesi",
    subtitle_en: "Four Rows Semi-Automatic Potato Planter",
    description_tr: "PDO-4N, orta ölçekli çiftlikler için tasarlanmış 4 sıralı yarı otomatik patates dikim makinesidir. 1300 kg kapasiteli hazne ile yüksek kapasiteli dikim sağlar.",
    description_en: "The PDO-4N is a 4-row semi-automatic potato planter designed for medium-sized farms. With a 1300 kg capacity hopper, it provides high capacity planting.",
    category: "potato-planters",
    image: "/images/pdo4n-1.jpg",
    specs: {
      workingWidth: "3500mm",
      rows: "4",
      rowSpacing: "70-75 cm",
      spacingAboveRows: "18-41 cm",
      hopperCapacity: "1300 kg",
      tractorPower: "Min. 90 hp",
      workingCapacity: "7-10 da/saat",
    },
    features_tr: [
      "Orta ölçekli çiftlikler için uygun",
      "4 sıralı yüksek kapasiteli dikim",
      "Standart boyutlu tohum kapları",
      "Isıl işlem görmüş ön ve arka bıçaklar",
    ],
    features_en: [
      "Suitable for medium-sized farms",
      "4-row high capacity planting",
      "Standard dimension seed cups",
      "Heat-treated front and rear blades",
    ],
  },
  "ULTRA275": {
    id: "ULTRA275",
    name: "ULTRA 275",
    subtitle_tr: "İki Sıralı Paletli Patates Söküm Makinesi",
    subtitle_en: "Double Rows Pallet Potato Harvester",
    description_tr: "ULTRA 275, HARDOX kalitesinde bıçaklar ve ısıl işlem görmüş ithal kalite palet ile her toprak tipinde güvenilir hasat sağlayan paletli patates söküm makinesidir. Düşük arıza oranı ve işçilik tasarrufu sunar.",
    description_en: "The ULTRA 275 is a pallet potato harvester with HARDOX quality blades and heat-treated imported quality pallets, providing reliable harvesting in all soil types. It offers low failure rate and labor savings.",
    category: "potato-harvesters",
    image: "/images/patatessokum.jpg",
    specs: {
      workingWidth: "1400mm",
      rows: "2",
      workingDepth: "20-25 cm",
      tractorPower: "Min. 70 hp",
      workingCapacity: "2.5 da/saat",
    },
    features_tr: [
      "HARDOX kalitesinde bıçaklar",
      "Isıl işlem görmüş ithal kalite palet",
      "Her toprak tipine uygun",
      "Düşük arıza oranı",
      "İşçilik tasarrufu sağlar",
    ],
    features_en: [
      "HARDOX quality blades",
      "Heat-treated imported quality pallet",
      "Suitable for all soil types",
      "Low failure rate",
      "Provides labor savings",
    ],
  },
  "ULTRA475": {
    id: "ULTRA475",
    name: "ULTRA 475",
    subtitle_tr: "Dört Sıralı Paletli Patates Söküm Makinesi",
    subtitle_en: "Four Rows Pallet Potato Harvester",
    description_tr: "ULTRA 475, 4 sıralı yüksek kapasiteli hasat yapabilen güçlü bir paletli patates söküm makinesidir. HARDOX kalitesinde bıçaklar ve geniş çalışma genişliği ile büyük tarlalarda verimli hasat sağlar.",
    description_en: "The ULTRA 475 is a powerful 4-row pallet potato harvester capable of high capacity harvesting. With HARDOX quality blades and wide working width, it ensures efficient harvesting in large fields.",
    category: "potato-harvesters",
    image: "/images/ultra475-1.jpg",
    specs: {
      workingWidth: "3000mm",
      rows: "4",
      workingDepth: "20-25 cm",
      tractorPower: "Min. 110 hp",
      workingCapacity: "5 da/saat",
    },
    features_tr: [
      "4 sıralı yüksek kapasiteli hasat",
      "HARDOX kalitesinde bıçaklar",
      "Isıl işlem görmüş ithal kalite palet",
      "Geniş çalışma genişliği",
      "Düşük arıza oranı",
    ],
    features_en: [
      "4-row high capacity harvesting",
      "HARDOX quality blades",
      "Heat-treated imported quality pallet",
      "Wide working width",
      "Low failure rate",
    ],
  },
  "PSH-2S": {
    id: "PSH-2S",
    name: "PSH-2S",
    subtitle_tr: "İki Sıralı Yarım Palet Yarım Elekli Patates Söküm Makinesi",
    subtitle_en: "Double Rows Half Pallet Half Sieve Potato Harvester",
    description_tr: "PSH-2S, hafif ve taşlı topraklar için uygun, palet ve titreşimli elek ile çift eleme yapan bir patates söküm makinesidir. Kolay kullanımı ve düşük arıza oranı ile öne çıkar.",
    description_en: "The PSH-2S is a potato harvester suitable for light and stony soil, featuring dual sifting via pallet and vibrating sieve. It stands out with easy operation and low failure rate.",
    category: "potato-harvesters",
    image: "/images/psh2s-1.jpg",
    specs: {
      workingWidth: "1650mm",
      rows: "2",
      workingDepth: "20-25 cm",
      tractorPower: "Min. 65 hp",
      workingCapacity: "3 da/saat",
      sievingArea: "1.40 m2",
    },
    features_tr: [
      "Hafif ve taşlı topraklar için uygun",
      "Palet ve titreşimli elek ile çift eleme",
      "Düşük arıza oranı",
      "Kolay kullanım",
    ],
    features_en: [
      "Suitable for light and stony soil",
      "Dual sifting via pallet and vibrating sieve",
      "Low failure rate",
      "Easy to use",
    ],
  },
  "SSM-1400": {
    id: "SSM-1400",
    name: "SSM-1400",
    subtitle_tr: "Soğan Söküm Makinesi",
    subtitle_en: "Onion Harvester",
    description_tr: "SSM-1400, profesyonel soğan hasadı için tasarlanmış verimli ve hızlı bir söküm makinesidir. Dayanıklı yapısı ve kolay bakımı ile uzun yıllar güvenilir performans sunar.",
    description_en: "The SSM-1400 is an efficient and fast harvester designed for professional onion harvesting. With its durable construction and easy maintenance, it offers reliable performance for years.",
    category: "onion-harvesters",
    image: "/images/sokum.jpg",
    specs: {
      workingWidth: "1420mm",
      tractorPower: "65 hp",
      workingCapacity: "0.3 ha/h",
    },
    features_tr: [
      "Profesyonel soğan hasadı için tasarlandı",
      "Verimli ve hızlı hasat",
      "Dayanıklı yapı",
      "Kolay bakım",
    ],
    features_en: [
      "Designed for professional onion harvesting",
      "Efficient and fast harvesting",
      "Durable construction",
      "Easy maintenance",
    ],
  },
};

export const categoryImages = {
  "soil-preparation": "/images/toprakhazirlamaekipmanlari.jpeg",
  "potato-planters": "/images/patatesdikimekipmanlari.jpg",
  "potato-harvesters": "/images/patatessokumekipmanlari.jpg",
  "onion-harvesters": "/images/sogansokumekipmanlari.jpeg",
};

// Machine overlay images for hover effect (like hmsagro)
export const categoryMachineImages = {
  "soil-preparation": "https://customer-assets.emergentagent.com/job_doc-site-3/artifacts/vv0nvh0v_toprak%20hazirlama.png",
  "potato-planters": "https://customer-assets.emergentagent.com/job_doc-site-3/artifacts/fg5jbcnh_ekim%20%283%29-fotor-bg-remover-20260406175434.png",
  "potato-harvesters": "https://customer-assets.emergentagent.com/job_doc-site-3/artifacts/edain816_ULTRA475%20SOKUM%20%282%29-fotor-bg-remover-20260406175531.png",
  "onion-harvesters": "https://customer-assets.emergentagent.com/job_doc-site-3/artifacts/edain816_ULTRA475%20SOKUM%20%282%29-fotor-bg-remover-20260406175531.png",
};

// Gallery images for product detail pages (per-product)
export const productGallery = {
  "HT475": ["/images/ht475-1.jpg", "/images/ht475-2.jpg"],
  "SPIDER275": ["/images/toprakhazirlama.jpg"],
  "SPIDER475": ["/images/spider475-1.jpg", "/images/spider475-2.jpg"],
  "ALPHA275": ["/images/alpha275-1.jpg", "/images/alpha275-2.jpg"],
  "ALPHA475": ["/images/alpha475-1.jpg", "/images/alpha475-2.jpg"],
  "PDO-2N": ["/images/pdo2n-1.jpg", "/images/pdo2n-2.jpg", "/images/pdo2n-3.jpg"],
  "PDO-2F": ["/images/pdo2n-1.jpg", "/images/pdo2n-2.jpg", "/images/pdo2n-3.jpg"],
  "PDO-4N": ["/images/pdo4n-1.jpg"],
  "ULTRA275": ["/images/patatessokum.jpg", "/images/patatessokum2.jpeg", "/images/patatessokum3.jpeg"],
  "ULTRA475": ["/images/ultra475-1.jpg", "/images/ultra475-2.jpg", "/images/ultra475-3.jpg"],
  "PSH-2S": ["/images/psh2s-1.jpg", "/images/psh2s-2.jpg", "/images/psh2s-3.jpg"],
  "SSM-1400": ["/images/sokum.jpg"],
};

export const getProductsByCategory = (categoryId) => {
  return Object.values(products).filter(p => p.category === categoryId);
};
